<div class="background" *ngIf="validateModal()"></div>

<!-- Formulario de gateway: se abre en modal cuando SettingsService.GatewayForm.status es true -->
<ng-template #gatewayFormModal>
  <app-network-gateway></app-network-gateway>
</ng-template>
